// opervex-frontend/src/Opervex/Report/ServiceOrder.js

class ServiceOrder {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "protocol",
        label: "Protocolo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "idTask",
        label: "ID Tarefa",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "customerId",
        label: "Código Cliente",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "customerName",
        label: "Nome Cliente",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "branch",
        label: "Unidade",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "branchText",
        label: "Texto Unidade",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "city",
        label: "Cidade",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "cityText",
        label: "Texto Cidade",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do documento",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
      {
        key: "reversed",
        label: "Estornado",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "reversal",
        label: "Código Estorno",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "reversalText",
        label: "Texto Estorno",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "createByUsername",
        label: "Usuário Criador",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "createByName",
        label: "Criado por",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "createOn",
        label: "Data de Criação",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "gmId",
        label: "Movimentação",
        type: "number",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default ServiceOrder;
